export default {
  'en-US': {
    filters: {
      operators: {
        default: {
          Equal: 'Exactly',
          NotEqual: 'Not Equal To',
          LessThan: 'Less Than',
          LessThanOrEqual: 'Less Than or Exactly',
          GreaterThan: 'More Than',
          GreaterThanOrEqual: 'More Than or Exactly'
        },
        date: {
          Equal: 'Exactly',
          NotEqual: 'Not Equal To',
          LessThan: 'Before',
          LessThanOrEqual: 'Before or On',
          GreaterThan: 'After',
          GreaterThanOrEqual: 'After or On'
        },
        contains: {
          Equal: 'Contains',
          NotEqual: 'Does Not Contain',
          LessThan: 'Less Than',
          LessThanOrEqual: 'Less Than or Exactly',
          GreaterThan: 'More Than',
          GreaterThanOrEqual: 'More Than or Exactly'
        }
      }
    }
  },
  'ja-JP': {
    filters: {
      operators: {
        default: {
          Equal: '正確に',
          NotEqual: '等しくない',
          LessThan: '未満',
          LessThanOrEqual: '少ないまたは正確に',
          GreaterThan: 'より多い',
          GreaterThanOrEqual: 'より多くまたは正確に'
        },
        date: {
          Equal: '正確に',
          NotEqual: '等しくない',
          LessThan: '前',
          LessThanOrEqual: '前または後',
          GreaterThan: '後',
          GreaterThanOrEqual: '後またはオン'
        },
        contains: {
          Equal: '含有',
          NotEqual: '含まれない',
          LessThan: '未満',
          LessThanOrEqual: '少ないまたは正確に',
          GreaterThan: 'より多い',
          GreaterThanOrEqual: 'より多くまたは正確に'
        }
      }
    }
  }
}

